import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./DetailedInquiry.module.css";
import Header from "../../components/header/Header";
import {
  User,
  Phone,
  Mail,
  Briefcase,
  MapPin,
  Globe,
  FileText,
  Hash,
  Award,
  Flag,
  Home,
  Map,
  Mail as MailBulk,
  CreditCard,
  Table,
} from "react-feather";
import { FiEye, FiEdit2, FiTrash2 } from "react-icons/fi";
import "../../assets/styles/table.css";
import { IInventory } from "../../types";
import PageHeading from "../../components/PageHeading/PageHeading";
import { useGetInquiryDetailsQuery } from "../../store/api/inquiryApi";
import { useParams } from "react-router-dom";

const DetailedInquiry: React.FC = () => {
  const navigate = useNavigate();
  const { id: inquiryId } = useParams<{ id: string }>();
  const { data, isLoading } = useGetInquiryDetailsQuery(Number(inquiryId));
  const inquiry = data?.data;

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.mainContent}>
        <PageHeading title="Inquiry Details" />
        <div className={styles.content}>
          <div className={styles.leftPanel}>
            <div className={styles.ownerInfo}>
              <div className={styles.ownerInfoCard}>
                <span className={styles.userIcon}>
                  <Briefcase />
                </span>
                <div className={styles.ownerName}>
                  {inquiry?.inquiry.business_name || "-"}
                </div>
              </div>
              <div className={styles.OwnerDetailHorizontalDivider} />
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>
                  <User />
                </span>
                <div className={styles.infoValue}>
                  {inquiry?.inquiry.owner_name || "-"}
                </div>
              </div>
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>
                  <Phone />
                </span>
                <div className={styles.infoValue}>
                  {inquiry?.inquiry.owner_phone || "-"}
                </div>
              </div>
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>
                  <Mail />
                </span>
                <div className={styles.infoValue}>
                  {inquiry?.inquiry.email || "-"}
                </div>
              </div>
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>
                  <Globe />
                </span>

                <div className={styles.infoValue}>
                  <a
                    href={inquiry?.inquiry.website_url || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.portalUrl}
                  >
                    {inquiry?.inquiry.website_url || "-"}
                  </a>
                </div>
              </div>
              <div className={styles.infoCard}>
                <span className={styles.infoIcon}>
                  <MapPin />
                </span>
                <div className={styles.infoValue}>
                  {inquiry?.inquiry.address || "-"}
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className={styles.infoCard}>
                  <span className={styles.infoIcon}>
                    <Home />
                  </span>
                  <div className={styles.infoValue}>
                    {inquiry?.inquiry.city || "-"}
                  </div>
                </div>

                <div className={styles.infoCard}>
                  <span className={styles.infoIcon}>
                    <MailBulk />
                  </span>
                  <div className={styles.infoValue}>
                    {inquiry?.inquiry.postal_code || "-"}
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div className={styles.infoCard}>
                  <span className={styles.infoIcon}>
                    <MapPin />
                  </span>
                  <div className={styles.infoValue}>
                    {inquiry?.inquiry.state || "-"}
                  </div>
                </div>
                <div className={styles.infoCard}>
                  <span className={styles.infoIcon}>
                    <Flag />
                  </span>
                  <div className={styles.infoValue}>
                    {inquiry?.inquiry.country || "-"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.rightPanel}>
            <div className="tableWrapper">
              <table className="table">
                <thead>
                  <tr>
                    <th>Stock Number</th>
                    <th>Color</th>
                    <th>Grade</th>
                    <th>Cts.</th>
                    <th>P/ct</th>
                    <th>Certificate</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan={6}>Loading...</td>
                    </tr>
                  ) : inquiry?.inquiry?.items?.length ? (
                    inquiry.inquiry.items.map((item: any) => (
                      <tr key={item.id}>
                        <td>{item.serial_id || "-"}</td>
                        <td>{item.color || "-"}</td>
                        <td>{item.grade || "-"}</td>
                        <td>{item.carat || "-"}</td>
                        <td>
                          {item.price_per_carat
                            ? `$${item.price_per_carat}`
                            : "-"}
                        </td>
                        <td>{item.certificate_number || "-"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={6}>No data found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailedInquiry;
